import React, { useState } from 'react';
import "./FileInput.scss";

export const FileInput = ({ fileName, setFileName, name, setErrorMes, status, errorMes, setFileSize, inputKey, setInputKey }: any) => {

  const handleFileChange = (event: any) => {
    const files = event.target.files;
    if (files.length > 0) {
      const fileName = files[0].name;
      const extension = fileName.split('.').pop();
      const maxLength = 32;
      const truncatedName = fileName.slice(0, maxLength - extension.length - 1);
      const fileSize = files[0].size;
      setFileSize(fileSize);
      if (fileName.length <= maxLength) {
        setFileName(fileName);
      } else {
        setFileName(`${truncatedName}...${extension}`);
      }
    } else {
      setFileName('');
    }
  };


  const handleFileDelete = () => {
    setFileName('');
    setErrorMes('');
    setInputKey(Date.now())
    setFileSize(0);
  };

  return (
    <div className="input__wrapper">
      <input
        key={inputKey}
        name={name}
        type="file"
        id="input__file"
        className="input input__file"
        onChange={handleFileChange}
      />
      <label htmlFor="input__file" className="input__file-button">
        <div className="input__file-icon-wrapper">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 495 495">
          <path d="M305.356,469.4c-0.768-1.195-1.536-2.389-2.219-3.584l-1.536-2.731c0,0-0.427-0.768-0.683-1.195 c-0.256-0.427-1.451-2.816-2.133-4.267c-0.683-1.451-1.792-4.096-2.56-6.229c-0.838-2.06-1.55-4.169-2.133-6.315 c-0.671-2.04-1.212-4.121-1.621-6.229c-0.04-0.254-0.04-0.514,0-0.768c-0.427-2.048-0.853-4.096-1.109-6.144 c0-2.219-0.597-4.523-0.768-6.741c-0.171-2.219,0-4.181,0-6.315V418.2c-0.001-51.675,41.766-93.632,93.44-93.867 c2.816,0,5.717,0,8.533,0s6.827,0.853,10.24,1.536c3.413,0.683,4.608,1.024,6.827,1.707V111c0.088-0.68,0.088-1.368,0-2.048 c-0.432-1.543-1.29-2.933-2.475-4.011l-102.4-102.4c-1.078-1.185-2.468-2.043-4.011-2.475c-0.68-0.088-1.368-0.088-2.048,0H77.43 c-23.894,0-43.264,19.37-43.264,43.264v399.872c0,23.894,19.37,43.264,43.264,43.264h242.261l-2.645-2.56 C312.678,479.47,308.762,474.611,305.356,469.4z M349.9,247.533h-93.867c-4.713,0-8.533-3.82-8.533-8.533s3.82-8.533,8.533-8.533 H349.9c4.713,0,8.533,3.82,8.533,8.533S354.613,247.533,349.9,247.533z M358.433,273.133c0,4.713-3.82,8.533-8.533,8.533H196.3 c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.82-8.533,8.533-8.533h153.6C354.613,264.6,358.433,268.42,358.433,273.133z M307.233,29.165l73.301,73.301h-47.104c-14.449-0.047-26.151-11.748-26.197-26.197V29.165z M85.367,196.333H349.9 c4.713,0,8.533,3.82,8.533,8.533s-3.82,8.533-8.533,8.533H85.367c-4.713,0-8.533-3.821-8.533-8.533 S80.654,196.333,85.367,196.333z M85.367,230.466h128c4.713,0,8.533,3.82,8.533,8.533s-3.82,8.533-8.533,8.533h-128 c-4.713,0-8.533-3.82-8.533-8.533S80.654,230.466,85.367,230.466z M85.367,264.6h76.8c4.713,0,8.533,3.821,8.533,8.533 c0,4.713-3.82,8.533-8.533,8.533h-76.8c-4.713,0-8.533-3.821-8.533-8.533C76.833,268.42,80.654,264.6,85.367,264.6z M76.833,307.266c0-4.713,3.82-8.533,8.533-8.533H349.9c4.713,0,8.533,3.82,8.533,8.533c0.02,1.21-0.243,2.408-0.768,3.499 c-0.147,0.395-0.348,0.769-0.597,1.109c-0.352,0.494-0.752,0.951-1.195,1.365c-0.329,0.358-0.702,0.674-1.109,0.939 c-0.436,0.338-0.926,0.598-1.451,0.768c-0.508,0.26-1.056,0.433-1.621,0.512L349.9,315.8H85.367 C80.654,315.8,76.833,311.979,76.833,307.266z" fill="#31465A"></path>
          <path d="M384.033,341.4c-42.415,0-76.8,34.385-76.8,76.8s34.385,76.8,76.8,76.8s76.8-34.385,76.8-76.8 S426.449,341.4,384.033,341.4z M418.167,426.733H401.1c-4.713,0-8.533,3.82-8.533,8.533v17.067H375.5v-17.067 c0-4.713-3.82-8.533-8.533-8.533H349.9v-17.067h17.067c4.713,0,8.533-3.82,8.533-8.533v-17.067h17.067v17.067 c0,4.713,3.82,8.533,8.533,8.533h17.067V426.733z" fill="#31465A"></path>
        </svg>
        </div>
        {fileName ? (
          <span className="input__file-button-text">{fileName}</span>
        ) : (
          <span className="input__file-button-text">Добавить прайс-лист (.txt, .pdf, .doc, .docx, .rtf, .xls, .xlsx, .csv)<br />
          (Максимальный размер файла: 25 МБ)
          </span>
        )}
      </label>
      {fileName &&
        <button className='input__file-button-delete' onClick={handleFileDelete}>x</button>
      }
      {status === 5 &&
        <div className="error-message">{errorMes}</div>
      }
    </div>
  );
}
